type SeverityLevel = "warning" | "high" | "critical";

type TagFilter = Record<string, string[]>; // tags_in: { Asset: ["T6", "T7"] }
type TagLikeFilter = Record<string, string>; // tags_like: { NodeAddress: "%2" }

// Relative threshold: each matched sensor is compared against the sensor named <its name> + name_suffix with identical
// tags, and Value becomes a multiplier of that reference's latest reading (1.0 = at the reference).
interface ThresholdReference {
  name_suffix: string;
  min_history_days?: number;
}

interface ThresholdSelector {
  sensor_name_like?: string;
  tags_in?: TagFilter;
  tags_like?: TagLikeFilter;
  reference?: ThresholdReference;
}

interface Threshold {
  ThresholdID: number | null;
  Name: string;
  Description: string | null;
  Selector: string; // JSON string from API
  Value: string | null;
  Severity: SeverityLevel | null;
  CreatedAt: string | null;
  Enabled: boolean;
  DashboardUID: string | null;
  Managed: boolean; // provisioned fleet-wide; read-only in the UI
}

interface LocalThreshold {
  ThresholdID: number | null;
  Name: string;
  Description: string | null;
  Selector: ThresholdSelector;
  Value: number | null;
  Severity: SeverityLevel | null;
  CreatedAt: string | null;
  Enabled: boolean;
  DashboardUID: string | null;
  Managed: boolean;
}

function toLocalThreshold(t: Threshold): LocalThreshold {
  console.log(t);
  return {
    ...t,
    Selector: JSON.parse(t.Selector) as ThresholdSelector,
    Value: t.Value !== null ? parseFloat(t.Value) : null,
    Enabled: t.Enabled,
  };
}

function toApiThreshold(t: LocalThreshold): Threshold {
  return {
    ...t,
    Selector: JSON.stringify(t.Selector),
    Value: t.Value !== null ? t.Value.toString() : null,
  };
}

interface AlertHistoryEntry {
  time: number;
  timeEnd: number;
  durationMs: number;
  asset: string;
  blade: string;
  node: string; // NodeAddress; empty on annotations predating the node label
}

interface AlertHistoryResponse {
  thresholdId: number;
  from: number;
  to: number;
  history: AlertHistoryEntry[];
  grafanaError: string | null;
}

export {
  Threshold,
  LocalThreshold,
  ThresholdSelector,
  ThresholdReference,
  TagFilter,
  TagLikeFilter,
  SeverityLevel,
  toLocalThreshold,
  toApiThreshold,
  AlertHistoryEntry,
  AlertHistoryResponse,
};
